export const INITIAL_STATE = {
  data: null,
  isFetching: false,
  error: false,
  isLogout: false,
};

export const request = (state, action) => {
  return {
    ...state,
    isFetching: true,
    isLogout: false,
  };
};

export const success = (state, action) => {
  return {
    ...state,
    data: action.data,
    isLogout: !action.data,
    isFetching: false,
    error: false,
  };
};

export const failure = (state, action) => {
  return {
    ...state,
    data: action.errData,
    isLogout: false,
    isFetching: false,
    error: true,
  };
};

export const reducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case "VERIFY_OTP_REQUESTED":
      return request(state, action);
    case "VERIFY_OTP_SUCCEEDED":
      return success(state, action);
    case "VERIFY_OTP_FAILED":
      return failure(state, action);
    case "REQ_LOGOUT_V2_SUCCEEDED":
      return success(state, action);
    case "RESET_VERIFY_OTP":
      return INITIAL_STATE;
    case "RESET_IS_LOGOUT":
      return INITIAL_STATE;
    default:
      return state;
  }
};
